import { render, staticRenderFns } from "./pesquisar-propinas-preco.vue?vue&type=template&id=7871e5b8&scoped=true&"
import script from "./pesquisar-propinas-preco.vue?vue&type=script&lang=js&"
export * from "./pesquisar-propinas-preco.vue?vue&type=script&lang=js&"
import style0 from "./pesquisar-propinas-preco.vue?vue&type=style&index=0&id=7871e5b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7871e5b8",
  null
  
)

export default component.exports